// extracted by mini-css-extract-plugin
module.exports = {"root":"ToyotaHero_root__30Ld-","logo":"ToyotaHero_logo__2tdAL","vertical_spacing":"ToyotaHero_vertical_spacing__19KfI","h1":"ToyotaHero_h1__ExAL7"};